import { Injectable } from '@angular/core';
import {
  FoxitModule,
  PDFUIOptions,
} from 'webcommon/lazy-load-commonjs/foxit';
import { FoxitLicenseDto } from 'webcommon/shared';
import { FoxitPdfRendererBase } from './FoxitPdfRendererBase';

@Injectable()
export class FoxitRpnViewRenderer extends FoxitPdfRendererBase {
  override readonly pdfUI = this.createPDFUI();

  protected override getNewTemplate(): PDFUIOptions['template'] {
    return `
    <webpdf>
      <toolbar name="toolbar" class="fv__ui-toolbar-scrollable">
        <group-list name="home-toolbar-group-list" class="mb_10">
          <group name="comment-tab-group-stamp" retain-count="2">
            <single-page-button></single-page-button>
            <continuous-page-button></continuous-page-button>
          </group>
          <group name="home-tab-group-nav" retain-count="2">
            <goto-page-input></goto-page-input>
          </group>
          <group name="home-tab-group-zoom">
            <zoom-out-button></zoom-out-button>
            <editable-zoom-dropdown></editable-zoom-dropdown>
            <zoom-in-button></zoom-in-button>
          </group>
        </group-list>

        <!-- Add the other action buttons here. -->
      </toolbar>
      <div class="fv__ui-body">
        <sidebar name="sidebar">
          <search-sidebar-panel></search-sidebar-panel>
        </sidebar>
        <viewer></viewer>
      </div>
    </webpdf>
    `;
  }

  protected override createConfig(foxitSetup: FoxitLicenseDto): FoxitLicenseDto {
    const defaultConfig = super.createConfig(foxitSetup);
    return {
      ...defaultConfig,
      DefaultViewMode: 'continuous-view-mode',
    };
  }

  protected override getOptions(foxitModule: FoxitModule, foxitSetup: FoxitLicenseDto, element: HTMLElement): PDFUIOptions {
    const defaultOptions = super.getOptions(foxitModule, foxitSetup, element);
    defaultOptions.viewerOptions.defaultScale = 1;
    return defaultOptions;
  }
}
